import { render, staticRenderFns, recyclableRender, components } from "./cameraData.vue?vue&type=template&id=cf10d776&"
var renderjs
import script from "./cameraData.vue?vue&type=script&lang=js&"
export * from "./cameraData.vue?vue&type=script&lang=js&"
import style0 from "./cameraData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/index/cameraData.vue"
export default component.exports